<template>
  <div>
    <sc-collapse
      class="card">
      <div
        slot="trigger"
        slot-scope="props">
        <div
          class="card-header">
          <strong
            class="card-header-title">
            <sc-icon
              icon="info-circle"
              class="additional-information__icon"
              size="is-small" />
              Informações adicionais
          </strong>
          <a
            class="card-header-icon">
            <sc-icon
              v-if="props.open"
              icon="arrow-up"
              size="is-small" />
            <sc-icon
              v-else
              icon="arrow-down"
              size="is-small" />
          </a>
        </div>
      </div>
      <div
        class="card-content">
        <div
          class="columns">
          <div
            class="column is-narrow">
            <sc-field
              prop="free_shipping"
              label="Frete grátis">
              <sc-switch
                v-model="fields.additional_information.free_shipping" />
            </sc-field>
          </div>
          <div
            class="column is-narrow">
            <sc-field
              prop="exempt_from_icms"
              label="Isento de ICMS">
              <sc-switch
                v-model="fields.additional_information.exempt_from_icms" />
            </sc-field>
          </div>
          <div
            class="column">
            <sc-field
              prop="extra_cost_absolute"
              label="Adicional no frete absoluto">
              <sc-input-currency
                v-model="fields.additional_information.extra_cost_absolute"/>
            </sc-field>
          </div>
          <div
            class="column">
            <sc-field
              prop="extra_cost_percentage"
              label="Adicional em % do frete">
              <sc-input-percent
                v-model="fields.additional_information.extra_cost_percentage"
              />
            </sc-field>
          </div>
          <div
            class="column">
            <sc-field
              prop="additional_business_days"
              label="Dias adicionais no prazo">
              <sc-decimal
                placeholder="Digite a quantidade de dias adicionais"
                :precision="0"
                v-model="fields.additional_information.additional_business_days"
              />
            </sc-field>
          </div>
        </div>
        <div class="columns">
          <div class="column is-narrow">
            <sc-field
              prop="shipped_date"
              label="Data de despacho">
              <sc-datepicker
                v-model="fields.additional_information.shipped_date"
              />
            </sc-field>
          </div>
          <div
            class="column is-narrow">
            <sc-field
              :addons="true"
              :label="federalTaxPayerType(fields)"
            >
              <sc-field
                prop="federal_tax_payer_type"
              >
                <sc-select
                  v-model="fields.additional_information.federal_tax_payer_type"
                  @input="changefederalTaxPayerType">
                  <option
                    v-for="taxpayer in taxpayerListType"
                    :key="taxpayer.value"
                    :value="taxpayer.value"
                  >
                    {{ taxpayer.label }}
                  </option>
                </sc-select>
                <sc-input
                  :placeholder="taxpayer.placeholder"
                  v-mask="taxpayer.mask"
                  v-model="fields.additional_information.taxpayer"
                  :key="additional_information_key"
                />
              </sc-field>
            </sc-field>
          </div>
          <div
            class="column">
            <sc-field
              prop="sales_channel"
              label="Canal de vendas">
              <sc-input
                placeholder="Digite o canal de vendas"
                v-model="fields.additional_information.sales_channel" />
            </sc-field>
          </div>
          <div
            class="column">
            <sc-field
              prop="client_type"
              label="Tipo de cliente">
              <sc-input
                placeholder="Digite o tipo de cliente"
                v-model="fields.additional_information.client_type" />
            </sc-field>
          </div>
        </div>
        <div
          v-if="showLogistics"
          class="columns">
          <div
            class="column is-narrow">
            <sc-field label="Transportadora">
              <sc-logistic-provider-dropdown v-model="logisticProviderId" />
            </sc-field>
          </div>
          <div
            class="column">
            <sc-field
              label="Métodos selecionados">
              <sc-delivery-method-dropdown
                multiple
                :logistic-provider-id="logisticProviderId"
                v-model="fields.additional_information.delivery_method_ids"
              />
            </sc-field>
          </div>
        </div>
      </div>
    </sc-collapse>
  </div>
</template>

<script>
import {
  ScIcon,
  ScInput,
  ScInputPercent,
  ScInputCurrency,
  ScField,
  ScCollapse,
  ScDecimal,
  ScButton,
  ScSwitch,
  ScDatepicker,
  ScDeliveryMethodDropdown,
  ScLogisticProviderDropdown,
  ScSelect,
  ScTaginput,
} from '@intelipost-js/secure-components';
import EnumFederalTaxpayerType from './enums/EnumFederalTaxpayerType';
import EnumFederalTaxpayer from './enums/EnumFederalTaxpayer';

export default {
  name: 'sc-additional-information',
  props: {
    showDraftLogistics: Boolean,
    fields: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showLogistics: true,
      taxpayerListType: EnumFederalTaxpayerType,
      isOpen: false,
      logisticProviderId: 1,
      tooggleTaxpayer: false,
      additional_information_key: 0,
    };
  },
  computed: {
    taxpayer() {
      const {
        additional_information: {
          federal_tax_payer_type,
        } = {},
      } = this.fields;
      return EnumFederalTaxpayer[federal_tax_payer_type] || {};
    },
  },
  methods: {
    federalTaxPayerType(fields) {
      const {
        additional_information,
      } = fields;
      const {
        federal_tax_payer_type,
      } = additional_information;
      return federal_tax_payer_type === 'cpf' ? 'CPF' : 'CNPJ';
    },
    changefederalTaxPayerType() {
      this.fields.additional_information.taxpayer = '';
      this.additional_information_key = this.additional_information_key + 1;
    },
  },
  mounted() {
    const {
      showDraftLogistics,
    } = this;
    if (showDraftLogistics) {
      this.showLogistics = false;
    }
  },
  components: {
    ScIcon,
    ScInput,
    ScInputCurrency,
    ScField,
    ScCollapse,
    ScDecimal,
    ScButton,
    ScInputPercent,
    ScSwitch,
    ScDatepicker,
    ScDeliveryMethodDropdown,
    ScLogisticProviderDropdown,
    ScSelect,
    ScTaginput,
  },
};
</script>
<style lang="scss" scoped>
.additional-information__icon {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-additional-information/ScAdditionalInformation.vue